<template>
  <el-row class="wrapper">
    <el-col :span="24">
      <!-- <p style="margin-top: 5px; font-size: 10px">
        {{ completedAchievements }} of {{ totalAchievements }} complete
      </p> -->
      <div style="background: white; position: relative">
        <span style="font-size: 12px; color: grey">Progress:</span>
        <span style="color: black; font-size: 14px; font-weight: bold">
          {{
            parseInt((completedAchievements / totalAchievements) * 100)
          }}%</span
        >
        <div
          style="
            position: absolute;
            top: 5px;
            right: 5px;
            width: calc(100% - 100px);
            height: 12px;
          "
        >
          <div
            style="
              width: 100%;
              position: absolute;
              height: 12px;
              background: #f1f1f1;
              border-radius: 7px;
            "
          ></div>
          <div
            :style="{
              width:
                parseInt((completedAchievements / totalAchievements) * 100) +
                '%',
            }"
            class="activeProgressBar"
          ></div>
        </div>
        <hr />
        <achievement
          :key="index"
          v-for="(item, index) in achievements"
          :opened="!item.completed"
          :progress="5 + 15 * index"
          :completed="item.achie"
          :item="item"
        ></achievement>
      </div>
    </el-col>
  </el-row>
</template>
<style scoped>
div.details {
  margin-left: 20px;
}
h4 {
  margin-bottom: 5px;
}
.greyProgressBar {
  width: 100%;
  position: absolute;
  height: 20px;
  background: #f1f1f1;
  border-radius: 5px;
}
.activeProgressBar {
  position: absolute;
  height: 12px;
  background: rgb(253, 29, 29);
  background: linear-gradient(90deg, #0dac7c 0%, #13bbb3 100%);
  border-radius: 4px;
}
</style>
<script>
import Achievement from "@/components/dashboard/Achievement.vue";
export default {
  name: "AchievementsSection",
  components: {
    Achievement,
  },
  data() {
    return {
      active: this.opened || true,
    };
  },
  props: {
    totalAchievements: Number,
    completedAchievements: Number,
    achievements: Array,
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    goto() {
      alert("going somewhere");
    },
  },
};
</script>
